import styled from "styled-components";
import { Box, Drawer, drawerClasses } from "@mui/material";
import { Center, Hover } from "styles/GlobalCss";
import { styled as muiStyled } from '@mui/material/styles';

export const WordWithFrequency = styled.div`
border:${props => `2px solid ${props.color}`};
border-radius: 6px;
${Hover};
`

export const AssessmentCount = styled.div`
height:30px;
backgroun
`

export const WrapStatus = styled.div`
display:${props => props.hide && 'none'};
color:${props => props.color};
`

export const DrawerWordFrequency = muiStyled(Drawer)(({ theme, $systemUI }) => ({
    [`& .${drawerClasses.paper}, & .${drawerClasses.root}`]: {
    },
    '.drawer-content': {
        width: "525px",
        minHeight: "50%"
    },
    '.custom-footer': {
        display: "flex",
        columnGap: '4px',
        ...Center
    }
}));

export const EmptyScreenStyles = muiStyled(Box)(({ }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    rowGap: 22,
    flexGrow: 1,
    '.empty-screen-title': {
        fontSize: 24,
        fontWeight: "bold"
    },
    '.empty-screen-sub-title': {
        textAlign: "center",
        fontSize: 20
    },
    '.empty-lab': {
        width: 650,
        height: 350
    }
}));

export const WrapIDS = muiStyled(Box)(({ theme, $systemUI, len, index }) => ({
    display: "flex",
    columnGap: 5,
    alignItems: "center",
    '.next-icon': {
        opacity: !index && 0.5,
        pointerEvents: !index && "none"
    },
    '.prev-icon': {
        opacity: index === len - 1 && 0.5,
        pointerEvents: index === len - 1 && "none"
    }
}));

export const LabStyles = muiStyled(Box)(({ theme, $systemUI, len, index }) => ({
    height: "100%",
    overflow: "auto",
    '.lab-filters': {
        display: "flex",
        alignItems: "center"
    },
    '.open-graph-icon': {
        width: '50px',
        display: "flex",
        justifyContent: "end",
    },
    '.accuracy-tabs': {
        flexGrow: 1,
        display: 'flex',
        alignItems: 'center',
        columnGap: 5
    },
    '.wrap-accuracy-tabs': {
        width: '100%',
        display: "flex",
        justifyContent: "end",
        height: 50,

    }
}));
